import { useFormik } from 'formik';
import Select from 'react-select';
import { useAppDispatch } from '../../../../store/hooks';

import CustomAlert from '../../../../components/Shared/Alert/CustomAlert';
import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import useGetRotationPlan from '../../../../hooks/HR/use-get-RotationPlan';
import { addHolidays, getHolidaysList } from '../../../../store/HR/Raqeeb/HolidaysSlice';
import Loading from '../../../../components/Shared/Loader/Loading';

const AddHolidays = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();
  const { loading, error, RotationPlanOptions } = useGetRotationPlan();

  const formik = useFormik({
    initialValues: {
      holidayName: '',
      holidayName2: '',
      holidayDateFrom: '',
      holidayDateTo: '',
      rotationPlanId: '',
      description: '',
    },

    // validationSchema: AttendanceAdjustmentSchema(t),

    onSubmit: async (values) => {
      try {
        const response = await dispatch(
          addHolidays({
            holidayName: values.holidayName,
            holidayName2: values.holidayName2,
            holidayDateFrom: values.holidayDateFrom,
            holidayDateTo: values.holidayDateTo,
            rotationPlanId: values.rotationPlanId,
            description: values.description,
          })
        );
        // debugger;
        if (response?.payload?.succeeded === true) {
          CustomAlert({ action: 'Add' });
          formik.resetForm();
          dispatch(getHolidaysList({ id: values.rotationPlanId }));
          document.getElementById('closeModal')?.click();
        } else {
          CustomAlert({ action: 'Error', msg: response?.payload?.message });
          // formik.resetForm();
        }
      } catch (error) {
        console.log(error);
        formik.setSubmitting(false);
        CustomAlert({ action: 'Error' });
      }
    },
  });

  return (
    <>
      <Loading loading={loading} error={error}>
        <Form onSubmit={formik.handleSubmit}>
          <div className="row">
            <div className="col-xl-4">
              <div className="form-group mb-3">
                <label className="form-label">{t('LocalName')}</label>
                <Form.Control
                  className="form-control"
                  type="text"
                  autoComplete="off"
                  name="holidayName2"
                  onChange={formik.handleChange}
                  value={formik.values.holidayName2}
                  isInvalid={!!formik.errors.holidayName2}
                />
                <Form.Control.Feedback type="invalid">
                  {formik.errors.holidayName2}
                </Form.Control.Feedback>
              </div>
            </div>

            <div className="col-xl-4">
              <div className="form-group mb-3">
                <label className="form-label">{t('GlobalName')}</label>
                <Form.Control
                  className="form-control"
                  type="text"
                  autoComplete="off"
                  name="holidayName"
                  onChange={formik.handleChange}
                  value={formik.values.holidayName}
                  isInvalid={!!formik.errors.holidayName}
                />
                <Form.Control.Feedback type="invalid">
                  {formik.errors.holidayName}
                </Form.Control.Feedback>
              </div>
            </div>
            <div className="col-xl-4">
              <div className="form-group mb-3">
                <label className="form-label">{t('RotationPlan')}</label>
                <Select
                  classNamePrefix="react-select"
                  className="w-100"
                  isLoading={loading}
                  isSearchable={true}
                  isClearable
                  options={RotationPlanOptions}
                  value={
                    formik.values.rotationPlanId === null
                      ? null
                      : RotationPlanOptions?.find(
                          (f: any) => f.value === formik.values.rotationPlanId
                        )
                  }
                  onChange={(option) => {
                    formik.setFieldValue('rotationPlanId', option === null ? null : option.value);
                  }}
                  placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                />
                <div className="small">
                  {formik.touched.rotationPlanId && formik.errors.rotationPlanId}
                </div>
              </div>
            </div>

            <div className="col-xl-3">
              <div className="form-group mb-3">
                <label className="form-label">{t('Start Date')}</label>
                <Form.Control
                  className="form-control"
                  type="date"
                  autoComplete="off"
                  name="holidayDateFrom"
                  onChange={formik.handleChange}
                  value={formik.values.holidayDateFrom}
                  isInvalid={!!(formik.touched.holidayDateFrom && formik.errors.holidayDateFrom)}
                />
                <Form.Control.Feedback type="invalid">
                  {formik.touched.holidayDateFrom && formik.errors.holidayDateFrom}
                </Form.Control.Feedback>
              </div>
            </div>

            <div className="col-xl-3">
              <div className="form-group mb-3">
                <label className="form-label">{t('Date_TO')}</label>
                <Form.Control
                  className="form-control"
                  type="date"
                  autoComplete="off"
                  name="holidayDateTo"
                  onChange={formik.handleChange}
                  value={formik.values.holidayDateTo}
                  isInvalid={!!(formik.touched.holidayDateTo && formik.errors.holidayDateTo)}
                />
                <Form.Control.Feedback type="invalid">
                  {formik.touched.holidayDateTo && formik.errors.holidayDateTo}
                </Form.Control.Feedback>
              </div>
            </div>

            <div className="col-xl-6">
              <div className="form-group mb-3">
                <label className="form-label">{t('Note')}</label>
                <Form.Control
                  className="form-control"
                  as="textarea"
                  rows={1}
                  name="description"
                  onChange={formik.handleChange}
                  value={formik.values.description}
                />

                <div></div>
              </div>
            </div>
          </div>

          <hr />
          <div className="text-center">
            <div className="d-flex justify-content-between gap-2">
              <button
                disabled={formik.isSubmitting}
                type="submit"
                className="btn btn-lg btn-theme mb-1 w-100">
                {formik.isSubmitting ? (
                  <div className="spinner-border spinner-border-sm me-2"></div>
                ) : (
                  <i className="fas fa-save fa-lg fa-fw me-2"></i>
                )}
                {t('Add')}
              </button>
              <button
                type="button"
                className="btn btn-lg  btn-default mb-1 w-100"
                data-bs-dismiss="modal"
                id="closeModal">
                <i className="fa fa-power-off fa-fw me-1"></i> {t('Cancel')}
              </button>
            </div>
          </div>
        </Form>
      </Loading>
    </>
  );
};

export default AddHolidays;
